import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { COMPANIES_ENDPOINTS } from '../../api/endpoints/companies.endpoints';
import { SKIP_ERROR_HANDLER } from '../../http-context-token';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanyClientService {
  private api = inject(ApiService);
  private featureFlagsSubject = new BehaviorSubject<any | null>(null);

  getOwners(params): Observable<any> {
    return this.api.get<any>(COMPANIES_ENDPOINTS.V1.COMPANY_ADMINS, {
      params: params,
    });
  }

  createOwner(data): Observable<any> {
    return this.api.post<any>(COMPANIES_ENDPOINTS.V1.COMPANY_ADMINS, data);
  }

  getMembers(): Observable<any> {
    return this.api.get<any>(COMPANIES_ENDPOINTS.V1.COMPANY_MEMBERS);
  }

  createMember(data): Observable<any> {
    return this.api.post<any>(COMPANIES_ENDPOINTS.V1.COMPANY_MEMBERS, data);
  }
  
  companyFeaturesFlags(): Observable<any> {
    if (this.featureFlagsSubject.value !== null) {
      return of(this.featureFlagsSubject.value);
    }
    return this.api.get<any>(COMPANIES_ENDPOINTS.V1.FEATURE_FLAGS,  {
        context: new HttpContext().set(SKIP_ERROR_HANDLER, true)
    }).pipe(tap(
      data => this.featureFlagsSubject.next(data)
    ),
    catchError(error => {
      this.featureFlagsSubject.next(null);
      return throwError(() => error);
    })
    );
  }

  get currentFeatureFlag(): any | null {
    return this.featureFlagsSubject.value;
  }
}
